import { render, staticRenderFns } from "./myStartUp.vue?vue&type=template&id=32952cb4"
import script from "./myStartUp.vue?vue&type=script&lang=js"
export * from "./myStartUp.vue?vue&type=script&lang=js"
import style0 from "./myStartUp.vue?vue&type=style&index=0&id=32952cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports